var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-wrapper",attrs:{"ar":_vm.$i18n.locale === 'ar'}},_vm._l((_vm.tabs),function(key,item){return _c('span',{key:key,attrs:{"active":_vm.value == key},on:{"click":function($event){_vm.$emit('input', key); _vm.$emit('change', key)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }